import * as S from '@effect/schema/Schema';
import { Effect, Option, Request, RequestResolver } from 'effect';
import * as E from 'fp-ts/Either';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { RequestError } from '../requests/requestError';
import baindepotAccessories from '../responseData/baindepot/Accessory.json';
import baindepotBasins from '../responseData/baindepot/Basin.json';
import baindepotBaths from '../responseData/baindepot/Bath.json';
import baindepotCabinets from '../responseData/baindepot/Cabinet.json';
import baindepotHeating from '../responseData/baindepot/Heating.json';
import baindepotMirrors from '../responseData/baindepot/Mirror.json';
import baindepotShowerEnclosures from '../responseData/baindepot/Shower Enclosure.json';
import baindepotStorage from '../responseData/baindepot/Storage.json';
import baindepotToilets from '../responseData/baindepot/Toilet.json';
import baindepotVanityUnits from '../responseData/baindepot/Vanity Unit.json';
import bathdepotAccessories from '../responseData/bathdepot/Accessory.json';
import bathdepotBasins from '../responseData/bathdepot/Basin.json';
import bathdepotBaths from '../responseData/bathdepot/Bath.json';
import bathdepotCabinets from '../responseData/bathdepot/Cabinet.json';
import bathdepotHeating from '../responseData/bathdepot/Heating.json';
import bathdepotMirrors from '../responseData/bathdepot/Mirror.json';
import bathdepotShowerEnclosures from '../responseData/bathdepot/Shower Enclosure.json';
import bathdepotStorage from '../responseData/bathdepot/Storage.json';
import bathdepotToilets from '../responseData/bathdepot/Toilet.json';
import bathdepotVanityUnits from '../responseData/bathdepot/Vanity Unit.json';
import bsBasin from '../responseData/bathshack/Basin.json';
import bsBath from '../responseData/bathshack/Bath.json';
import bsCabinet from '../responseData/bathshack/Cabinet.json';
import bsCabinetOverwrite from '../responseData/bathshack/CabinetOverwrite.json';
import bsMirror from '../responseData/bathshack/Mirror.json';
import bsShower from '../responseData/bathshack/Shower Enclosure.json';
import bsStorage from '../responseData/bathshack/Storage.json';
import bsStorageOverwrite from '../responseData/bathshack/StorageOverwrite.json';
import bsToilet from '../responseData/bathshack/Toilet.json';
import bsVanity from '../responseData/bathshack/Vanity Unit.json';
import bdaVanityDaDk from '../responseData/bda/vanity-da-DK.json';
import bdaVanityEnGb from '../responseData/bda/vanity-en-GB.json';
import ebAccessories from '../responseData/easybathrooms/Accessory.json';
import ebBasins from '../responseData/easybathrooms/Basin.json';
import ebBaths from '../responseData/easybathrooms/Bath.json';
import ebHeating from '../responseData/easybathrooms/Heating.json';
import ebMirrors from '../responseData/easybathrooms/Mirror.json';
import ebTrayShowers from '../responseData/easybathrooms/Shower With Tray.json';
import ebStorage from '../responseData/easybathrooms/Storage.json';
import ebToilets from '../responseData/easybathrooms/Toilet.json';
import ebVanityUnits from '../responseData/easybathrooms/Vanity Unit.json';
import ebWalkInShowers from '../responseData/easybathrooms/Walk In Shower.json';
import fixtuurAccessories from '../responseData/fixtuur/Accessory.json';
import fixtuurBasins from '../responseData/fixtuur/Basin.json';
import fixtuurBaths from '../responseData/fixtuur/Bath.json';
import fixtuurStorage from '../responseData/fixtuur/Cabinet.json';
import fixtuurHeating from '../responseData/fixtuur/Heating.json';
import fixtuurMirrors from '../responseData/fixtuur/Mirror.json';
import fixtuurShowers from '../responseData/fixtuur/Shower Enclosure.json';
import fixtuurToilets from '../responseData/fixtuur/Toilet.json';
import fixtuurVanityUnits from '../responseData/fixtuur/Vanity Unit.json';
import fixtuurAstridSofa from '../responseData/fixtuur/configurator-astrid-sofa.json';
import fixtuurMorvenSofa from '../responseData/fixtuur/configurator-morven-sofa.json';
import healsAstridSofa from '../responseData/heals/configurator-astrid-sofa.json';
import healsAurelieSofa from '../responseData/heals/configurator-aurelie-sofa.json';
import healsLilliSofa from '../responseData/heals/configurator-lilli-sofa.json';
import healsMorvenSofa from '../responseData/heals/configurator-morven-sofa.json';
import healsTailorSofa from '../responseData/heals/configurator-tailor-sofa.json';
import healsTogoSofa from '../responseData/heals/configurator-togo-sofa.json';
import newtechJuniorVanityUnits from '../responseData/newtech/juniorVanityUnits.json';
import newtechVanityUnits from '../responseData/newtech/vanityUnits.json';
// import newtechHeating from '../responseData/newtech/Heating.json';
// import newtechToilets from '../responseData/newtech/Toilet.json';
// import newtechAccessories from '../responseData/newtech/Accessory.json';
// import newtechMirrors from '../responseData/newtech/Mirror.json';
// import newtechBaths from '../responseData/newtech/Bath.json';
// import newtechStorage from '../responseData/newtech/Storage.json';
import sanctuaryAccessories from '../responseData/sanctuarybathrooms/Accessory.json';
import sanctuaryBasins from '../responseData/sanctuarybathrooms/Basin.json';
import sanctuaryBaths from '../responseData/sanctuarybathrooms/Bath.json';
import sanctuaryCabinets from '../responseData/sanctuarybathrooms/Cabinet.json';
import sanctuaryHeating from '../responseData/sanctuarybathrooms/Heating.json';
import sanctuaryMirrors from '../responseData/sanctuarybathrooms/Mirror.json';
import sanctuaryShowers from '../responseData/sanctuarybathrooms/Shower Enclosure.json';
import sanctuaryStorage from '../responseData/sanctuarybathrooms/Storage.json';
import sanctuaryToilets from '../responseData/sanctuarybathrooms/Toilet.json';
import sanctuaryVanityUnits from '../responseData/sanctuarybathrooms/Vanity Unit.json';
import testVanityEnGb from '../responseData/test/vanity-test-en-GB.json';
import vpingAccessories from '../responseData/victorianplumbing/Accessory.json';
import vpingBasins from '../responseData/victorianplumbing/Basin.json';
import vpingBaths from '../responseData/victorianplumbing/Bath.json';
import vpingHeating from '../responseData/victorianplumbing/Heating.json';
import vpingHeatingOverwrite from '../responseData/victorianplumbing/HeatingOverwrite.json';
import vpingMirrors from '../responseData/victorianplumbing/Mirror.json';
import vpingShowers from '../responseData/victorianplumbing/Shower.json';
import vpingStorage from '../responseData/victorianplumbing/Storage.json';
import vpingToilets from '../responseData/victorianplumbing/Toilet.json';
import vpingVanityUnits from '../responseData/victorianplumbing/Vanity Unit.json';
import zofaUtopiaSofa from '../responseData/zofa/configurator-utopia-sofa.json';
import zofaZenSofa from '../responseData/zofa/configurator-zen-sofa.json';
import stJohnMirror from '../responseData/34stjohn/Mirror.json';
import { ModuleType } from '../schemas/modularTemplate';
export const ConfigurableProperty = S.Struct({
    displayName: S.String, // the human-readable name of a property
    propertyValues: S.optionalWith(S.Record({
        key: 
        /**
         * propertyValueName is a string but some property values are numbers (or null).
         * This is okay because we should only ever be using these property value names for the
         * purpose of constructing display elements (filter options that show in the filter panel
         * etc.)
         *
         * And we should never be using these values to send to the API.
         *
         * In order to match property value names to actual property values, we need to convert the
         * actual property values to strings.
         */
        S.String,
        value: S.Struct({
            displayText: S.String, // text in the UI, e.g. "White Gloss"
            displayImage: S.optional(S.String), // image to be displayed alongside the option value, if option is a colour or finish
            displayColour: S.optional(S.String), // colour swatch to be displayed
        }),
    }), { default: () => ({}) }),
    groups: S.optional(S.Array(S.String)),
});
export const PropertyValue = S.Union(S.String, S.Number, S.Null);
export const AttachmentMap = S.Record({
    key: /* propertyAttachmentOption: */ S.String,
    value: S.Struct({
        displayName: S.String,
        options: S.Record({ key: /* attachmentPointName: */ S.String, value: S.String }),
    }),
});
export const PartsMap = S.Record({
    key: /* partId: */ S.String,
    value: S.Struct({
        properties: S.Array(S.String), // properties that relate to this part
        name: S.String, // user facing name for part
        icon: S.String, // location of icon to be used in the sidebar
        productProperty: S.String, // identifies which property to use to get the ProductId from this part
        display: S.optional(S.Boolean), // whether or not to display this part in the sidebar - should default to true
    }),
});
/**
 * Api.ConfiguratorDefinition
 * A document to describe how Visual Configuration (NPV) should be laid out
 * It contains information required for both app functionality and UI presentation
 */
export const ConfiguratorDefinition = S.Struct({
    id: S.String,
    // The name of the product or furniture represented eg. Vanity Unit, Shower Control.
    displayName: S.String,
    configurationSpaceId: S.String,
    stylePropertyWhitelist: S.Array(S.String),
    buildPropertyList: S.Array(S.String),
    configurableProperties: S.Record({ key: S.String, value: ConfigurableProperty }),
    configurablePropertiesDisplayOrder: S.optional(S.Array(S.String)),
    /** Sent to the API on every call to prioritise these selections over others */
    propertyPriorities: S.Record({ key: S.String, value: S.Array(PropertyValue) }),
    attachmentMap: AttachmentMap, // optional attachment points eg. left tap right tap
    partsMap: PartsMap,
});
export const ConfiguratorDefinitionEntry = ConfiguratorDefinition.pipe(S.omit('id'));
const decodeConfiguratorDefinitionEntry = S.decodeUnknownOption(ConfiguratorDefinitionEntry);
export const ModuleSection = S.Struct({
    displayName: S.String,
    moduleTypes: S.Union(S.Array(ModuleType), S.Literal('all')),
});
/**
 * Api.ModularConfiguratorDefinition
 * A document to describe how Modular Configuration should be shown
 */
export const ModularConfiguratorDefinition = S.Struct({
    id: S.String,
    // The name of the product or furniture represented eg. Vanity Unit, Shower Control.
    displayName: S.String,
    modularTemplateId: S.String,
    globalConfigurableProperties: S.Record({ key: S.String, value: ConfigurableProperty }),
    defaultGlobalSelections: S.Record({ key: S.String, value: S.String }),
    defaultPieces: S.NonEmptyArray(S.String),
});
const decodeModularConfigurator = S.decodeUnknownOption(ModularConfiguratorDefinition);
/**
 *
 * Why are we allowing configurator defintions to be partially overwritten?
 *
 * Due to the nature of A2VC (i.e. its intended purpose not being for 3DX),
 * the outputted configurator definitions sometimes require manual modifition
 * to fit the data format we need.
 *
 * Whenever A2VC is re-run for a tenant, there is a risk of these manual modifications accidentally being undone.
 *
 * The purpose of the overwrite file & function below is to minimise this risk by recording and
 * automatically applying the necessary changes.
 *
 * Note: this function acts on fields that aren't simple primitives, so fields like configuratbleProperties get entirely overwritten rather than merged.
 * This was fine for the particular requirement at the time but may not be useful for other situations, e.g. modifying a display name,
 * so please develop this function as needed!
 *
 */
const overwrite = (originalCd, overwriteCd) => Object.assign(originalCd, overwriteCd);
// Record of ConfiguratorDefinitions indexed by tenantId and locale
const configuratorsPerTenant = {
    test: { 'en-GB': { 'vanity-test-en-GB': testVanityEnGb } },
    'bda-da-dk': { 'da-DK': { 'vanity-da-DK': bdaVanityDaDk } },
    'bda-en-gb': { 'en-GB': { 'vanity-en-GB': bdaVanityEnGb } },
    newtech: {
        'en-GB': {
            vanity: newtechVanityUnits,
            juniorvanity: newtechJuniorVanityUnits,
            // Disable configurators below. Only generated via a2vc for unification testing. 2025/03/07
            // accessories: newtechAccessories,
            // heating: newtechHeating,
            // toilets: newtechToilets,
            // mirrors: newtechMirrors,
            // baths: newtechBaths,
            // storage: newtechStorage,
        },
    },
    victorianplumbing: {
        'en-GB': {
            accessories: vpingAccessories,
            baths: vpingBaths,
            heating: overwrite(vpingHeating, vpingHeatingOverwrite),
            mirrors: vpingMirrors,
            showers: vpingShowers,
            storage: vpingStorage,
            toilets: vpingToilets,
            vanities: vpingVanityUnits,
            basins: vpingBasins,
        },
    },
    bathdepot: {
        'en-CA': {
            accessories: bathdepotAccessories,
            basins: bathdepotBasins,
            baths: bathdepotBaths,
            cabinets: bathdepotCabinets,
            heating: bathdepotHeating,
            mirrors: bathdepotMirrors,
            showers: bathdepotShowerEnclosures,
            storage: bathdepotStorage,
            toilets: bathdepotToilets,
            vanities: bathdepotVanityUnits,
        },
    },
    baindepot: {
        'fr-CA': {
            accessories: baindepotAccessories,
            basins: baindepotBasins,
            baths: baindepotBaths,
            cabinets: baindepotCabinets,
            heating: baindepotHeating,
            mirrors: baindepotMirrors,
            showers: baindepotShowerEnclosures,
            storage: baindepotStorage,
            toilets: baindepotToilets,
            vanities: baindepotVanityUnits,
        },
    },
    'bathshack-gb': {
        'en-GB': {
            basins: bsBasin,
            baths: bsBath,
            cabinets: overwrite(bsCabinet, bsCabinetOverwrite),
            mirrors: bsMirror,
            showers: bsShower,
            storage: overwrite(bsStorage, bsStorageOverwrite),
            toilets: bsToilet,
            vanities: bsVanity,
        },
    },
    'bathshack-ie': {
        'en-IE': {
            basins: bsBasin,
            baths: bsBath,
            cabinets: bsCabinet,
            mirrors: bsMirror,
            showers: bsShower,
            storage: bsStorage,
            toilets: bsToilet,
            vanities: bsVanity,
        },
    },
    easybathrooms: {
        'en-GB': {
            accessories: ebAccessories,
            basins: ebBasins,
            baths: ebBaths,
            heating: ebHeating,
            mirrors: ebMirrors,
            trayShowers: ebTrayShowers,
            walkInShowers: ebWalkInShowers,
            storage: ebStorage,
            toilets: ebToilets,
            vanities: ebVanityUnits,
        },
    },
    fixtuur: {
        'en-GB': {
            accessories: fixtuurAccessories,
            basins: fixtuurBasins,
            baths: fixtuurBaths,
            heating: fixtuurHeating,
            mirrors: fixtuurMirrors,
            showers: fixtuurShowers,
            storage: fixtuurStorage,
            toilets: fixtuurToilets,
            vanities: fixtuurVanityUnits,
            'astrid-sofa': fixtuurAstridSofa,
            'morven-sofa': fixtuurMorvenSofa,
        },
    },
    sanctuarybathrooms: {
        'en-GB': {
            accessories: sanctuaryAccessories,
            basins: sanctuaryBasins,
            baths: sanctuaryBaths,
            cabinets: sanctuaryCabinets,
            heating: sanctuaryHeating,
            mirrors: sanctuaryMirrors,
            showers: sanctuaryShowers,
            storage: sanctuaryStorage,
            toilets: sanctuaryToilets,
            vanities: sanctuaryVanityUnits,
        },
    },
    heals: {
        'en-GB': {
            'aurelie-sofa': healsAurelieSofa,
            'lilli-sofa': healsLilliSofa,
            'astrid-sofa': healsAstridSofa,
            'morven-sofa': healsMorvenSofa,
            'tailor-sofa': healsTailorSofa,
            'togo-sofa': healsTogoSofa,
        },
    },
    zofa: {
        'en-GB': {
            'utopia-sofa': zofaUtopiaSofa,
            'zen-sofa': zofaZenSofa,
        },
    },
    '34stjohn': {
        'en-GB': {
            mirrors: stJohnMirror,
        },
    },
};
export const getConfiguratorDefinitionBySpaceId = (spaceId, tenantId, locale) => {
    return pipe(configuratorsPerTenant[tenantId][locale], E.fromNullable(RequestError.FetchError), E.map(configuratorsForTenant => {
        const configurators = Object.entries(configuratorsForTenant).flatMap(([id, configurator]) => {
            const parsed = decodeConfiguratorDefinitionEntry(configurator);
            return Option.isSome(parsed) ? [{ id, ...parsed.value }] : [];
        });
        const configurator = configurators.find(configurator => configurator.configurationSpaceId === spaceId);
        return configurator ?? null;
    }), E.chain(E.fromNullable(RequestError.FetchError)));
};
// For backwards compatibility with startConfiguration
export const getConfiguratorDefinitionById = (tenantId, id) => {
    const tenantConfigurators = configuratorsPerTenant[tenantId];
    const locales = Object.keys(tenantConfigurators);
    if (locales.length !== 1)
        return TE.left(new Error('tenant does not have exactly one locale'));
    const locale = locales[0];
    const configurator = tenantConfigurators[locale][id];
    if (!configurator) {
        return TE.left(new Error('not provided with valid configurator ID'));
    }
    const parsed = decodeConfiguratorDefinitionEntry(configurator);
    return Option.isSome(parsed)
        ? TE.right({ id, ...parsed.value })
        : TE.left(new Error('configurator not valid for standard config'));
};
export const getPropertiesForHero = (configuratorDefinition, heroPart) => {
    return configuratorDefinition.partsMap[heroPart].properties;
};
export const getBuildProperties = (configuratorDefinition, heroPart) => {
    const heroProperties = heroPart ? getPropertiesForHero(configuratorDefinition, heroPart) : [];
    return [...heroProperties, ...configuratorDefinition.buildPropertyList];
};
// A list of part IDs we wish to display
export const shouldDisplayPart = (configuratorDefinition, part) => {
    const partConfig = configuratorDefinition.partsMap[part];
    return partConfig ? (partConfig.display ?? true) : false;
};
export const GetModularConfigurator = Request.tagged('GetModularConfigurator');
export const GetModularConfiguratorResolver = RequestResolver.fromEffect((request) => Option.fromNullable(configuratorsPerTenant?.[request.tenant]?.[request.locale]?.[request.id]).pipe(Effect.map(configuratorDefinition => ({ id: request.id, ...configuratorDefinition })), Effect.andThen(decodeModularConfigurator)));
export const getModularConfiguratorById = (tenant, id, locale) => Effect.request(GetModularConfigurator({ tenant, locale, id }), GetModularConfiguratorResolver);
export const AnyConfiguratorDefinition = S.Union(ConfiguratorDefinition, ModularConfiguratorDefinition);
const decodeAnyConfigurator = S.decodeUnknownOption(AnyConfiguratorDefinition);
export const GetAnyConfigurator = Request.tagged('GetAnyConfigurator');
export const GetAnyConfiguratorResolver = RequestResolver.fromEffect((request) => Effect.fromNullable(configuratorsPerTenant?.[request.tenant]?.[request.locale]?.[request.id]).pipe(Effect.orElseFail(() => RequestError.FetchError), Effect.map(configuratorDefinition => ({ id: request.id, ...configuratorDefinition })), Effect.andThen(decodeAnyConfigurator)));
export const getAnyConfiguratorById = (tenant, id, locale) => Effect.request(GetAnyConfigurator({ tenant, locale, id }), GetAnyConfiguratorResolver);
